import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { IconType } from '../../../../../../types';

interface IArrow extends IconType {
  position: 'right' | 'left';
  isDisable?: boolean;
  disableColor?: string;
}

const NavigationArrow: FC<IArrow> = ({
  position,
  width = 16,
  height = 12,
  color = '#7A89A7',
  disableColor = '#EFF2F7',
  isDisable = false,
}) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={
        position === 'left'
          ? 'M8.16016 1.41L3.58016 6L8.16016 10.59L6.75016 12L0.750156 6L6.75016 0L8.16016 1.41Z'
          : 'M0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0L0 1.41Z'
      }
      fill={`${isDisable ? disableColor : color}`}
    />
  </svg>
);

NavigationArrow.propTypes = {
  color: PropTypes.string,
  disableColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  isDisable: PropTypes.bool,
};

NavigationArrow.defaultProps = {
  width: 12,
  height: 16,
  color: '#7A89A7',
  disableColor: '#EFF2F7',
  isDisable: false,
};

export default NavigationArrow;
